import React, { useEffect, useState } from "react";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import BackgroundMedia from "@/components/BackgroundMedia";
import BookingForm from "@/components/BookingForm";
import Seo from "@/components/Seo";
import { Container, SectionLabel } from "@/components/primitives";
import { api, mediaSrc } from "@/lib/api";

const FALLBACK_HERO = "https://images.unsplash.com/photo-1772442198907-765685249ea4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
const FALLBACK_POINTS = [
  { label: "Discover", body: "Walk through finishes, samples and curated artefacts in context." },
  { label: "Refine", body: "Workshop layout, palette and lighting alongside our designers." },
  { label: "Finalize", body: "Lock specifications for joinery, furniture, lighting and styling." },
];

export default function Experience() {
  const [doc, setDoc] = useState(null);
  useEffect(() => { api.getPage("experience").then(setDoc).catch(() => {}); }, []);
  const content = doc?.content || {};
  const hero = content.hero || {};
  const points = Array.isArray(content.three_points?.items) && content.three_points.items.length ? content.three_points.items : FALLBACK_POINTS;
  const booking = content.booking || {};
  const heroImg = hero.image_url ? mediaSrc(hero.image_url) : FALLBACK_HERO;
  const eyebrow = hero.eyebrow || "EXPERIENCE CENTER";
  const headline = hero.headline || "Not a showroom.\nA working design hub.";
  const sub = hero.sub || "By appointment. A collaborative environment to discover materials, refine details and finalize decisions with our studio team.";
  const bookingTitle = booking.title || "Book an Experience Visit";
  const bookingSubtitle = booking.subtitle || "Tell us a little about your project. We'll get back to you with available slots within one working day.";
  const ml = (t) => t.split("\n").map((line, i) => <span key={i} className="block">{line}</span>);

  return (
    <div className="min-h-screen bg-lux-bg">
      <Seo title="Experience Center · Onedot6" description={sub} path="/experience" />
      <TopBar />
      <div className="relative min-h-[480px] md:min-h-[640px] flex items-end overflow-hidden">
        <BackgroundMedia videoUrl={hero.video_url} imageUrl={heroImg} testId="exp-hero-media" />
        <div className="absolute inset-0 bg-gradient-to-b from-lux-ink/40 to-lux-ink/85 pointer-events-none" />
        <Container className="relative pt-40 pb-12 md:pb-24">
          <div className="max-w-[780px]">
            <SectionLabel light>{eyebrow}</SectionLabel>
            <h1 className="font-serif text-white font-light tracking-tight leading-tight mt-2 text-[clamp(2.5rem,6vw,4.5rem)]">{ml(headline)}</h1>
            <p className="text-white/80 font-light leading-relaxed mt-5 text-base md:text-lg">{sub}</p>
          </div>
        </Container>
      </div>
      <Container className="pt-16 md:pt-24 pb-24">
        <div className="flex flex-col md:flex-row gap-12 md:gap-20">
          <div className="flex-1 flex flex-col gap-6">
            {points.map((p, i) => (
              <div key={p.label || p.body || i} className="border-t border-lux-line pt-5">
                <p className="text-[11px] tracking-[0.28em] uppercase text-lux-accent mb-2">{(p.label || "").toUpperCase()}</p>
                <p className="font-serif text-lux-ink font-light leading-relaxed text-lg">{p.body}</p>
              </div>
            ))}
          </div>
          <div className="flex-1">
            <BookingForm type="experience" title={bookingTitle} subtitle={bookingSubtitle} />
          </div>
        </div>
      </Container>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
